import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4274de2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Reserve a Unit", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "form-field"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit", -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "form-field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "reservationPrice" }, "Reservation Price($)", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "form-field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Desired Move In Date", -1))
const _hoisted_18 = {
  key: 1,
  class: "form-field"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_20 = {
  key: 2,
  class: "form-field"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Caller phone Number", -1))
const _hoisted_22 = { class: "form-field" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "col"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Creating Reservation ")
const _hoisted_26 = {
  key: 1,
  class: "col"
}

import { ref, onMounted } from "vue";
import moment from "moment";

import api from "@virgodev/bazaar/functions/api";
import { useRouter, useRoute } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner.vue";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import Payment from "@/components/Payment.vue";
import { paymentAccountInterface } from "@/types/customers";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: true,
  },
  unitId: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const router = useRouter();
const route = useRoute();

const unit = ref();
const errors = ref("");
const selectedCustomer = ref();
const paymentAccounts = ref();
const formSubmitting = ref(false);
const reservationPrice = ref();
const status = ref("loading");
const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  payment_method: ref(),
  lead: {
    tenant_id: ref(props.customerId),
    unit_id: ref(props.unitId),
    is_reservation: true,
    desired_move_in_date: moment().format("YYYY-MM-DD"),
    notes_attributes: [
      {
        note: "",
      },
    ],
    caller_phone_number_attributes: {
      number: "",
    },
    payment_method: {
      payment_method_id: ref(null),
    },
  },
  contact: ref(),
});
onMounted(async () => {
  status.value = "loading";

  await getUnit();
  await getCustomer();
  await getPaymentAccounts();
  status.value = "loaded";
});
async function getUnit() {
  errors.value = "";
  const response = await api({
    url: `units/?id=${props.unitId}&sideload=true&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (response.body.length) {
      unit.value = response.body[0];
    } else {
      unit.value = response.body;
    }
    if (unit.value.unit_groups) {
      reservationPrice.value =
        unit.value.unit_groups[unit.value.unit.unit_group_id].reservation_fee ==
        0;
      if (!reservationPrice.value) {
        reservationPrice.value = 0;
      }
    } else {
      getReservationFee();
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getReservationFee() {
  const response = await api({
    url: `reservation_fee/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    if (!response.body[0].bReqReservationFee) {
      reservationPrice.value = 0;
    } else {
      reservationPrice.value = response.body[0].dcTotal;
    }
  } else {
    reservationPrice.value = 0;
  }
}
function addPaymentMethod(e: paymentAccountInterface) {
  formFields.value.payment_method = e.payment_method;
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}&include=contact`,
  });
  if (response.status == 200) {
    if (api_settings.extra_contact_info) {
      selectedCustomer.value = response.body.tenant;
      if (response.body.contact) {
        selectedCustomer.value.contact_info = response.body.contact;
      }
    } else {
      selectedCustomer.value = response.body[0];
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function submitForm() {
  if (api_settings.use_lead_id_with_reserve) {
    formFields.value.contact = selectedCustomer.value.contact_info["contact"];
  }
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (!json.contact) {
    delete json.contact;
  }
  formErrors.value = {};
  formSubmitting.value = true;
  let url = `reservations/?facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });

  formSubmitting.value = false;
  if ([200, 201].includes(responseData.status)) {
    if (
      reservationPrice.value > 0 &&
      api_settings.charge_separate_reserve_fee
    ) {
      await api({
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        url: `reservation_fee/?facilityId=${props.facilityId}&id=${responseData.body[0].Ret_Code}`,
        method: "POST",
        json,
      });
    }
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customer_detail_storedge",
            params: {
              id: props.customerId,
              facilityId: props.facilityId,
            },
          }
    );
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "large-width-centered",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          (unit.value)
            ? (_openBlock(), _createElementBlock("fieldset", _hoisted_3, [
                (selectedCustomer.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("input", {
                        value: 
            selectedCustomer.value.first_name + ' ' + selectedCustomer.value.last_name
          ,
                        type: "text",
                        disabled: ""
                      }, null, 8, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("input", {
                    type: "text",
                    disabled: "",
                    value: 
            unit.value.unit_groups
              ? unit.value.unit_groups[unit.value.unit.unit_group_id].size
              : unit.value.size
          
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("input", {
                    value: unit.value.unit ? unit.value.unit.name : unit.value.name,
                    type: "text",
                    disabled: ""
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reservationPrice).value = $event)),
                    type: "decimal",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, reservationPrice.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.lead.desired_move_in_date) = $event)),
                    type: "date"
                  }, null, 512), [
                    [_vModelText, formFields.value.lead.desired_move_in_date]
                  ])
                ]),
                (_unref(api_settings).notes_with_reserve)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.lead.notes_attributes[0].note) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.lead.notes_attributes[0].note]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(api_settings).reserve_caller_phone)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.lead.caller_phone_number_attributes.number) = $event)),
                        type: "text",
                        required: ""
                      }, null, 512), [
                        [_vModelText, formFields.value.lead.caller_phone_number_attributes.number]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (reservationPrice.value != 0)
                  ? (_openBlock(), _createBlock(Payment, {
                      key: 3,
                      "facility-id": __props.facilityId,
                      "customer-id": __props.customerId,
                      onPaymentMethod: addPaymentMethod
                    }, null, 8, ["facility-id", "customer-id"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              disabled: formSubmitting.value,
              type: "submit",
              class: "btn btn-text"
            }, [
              (formSubmitting.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(BaseSpinner)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_26, "Create Reservation"))
            ], 8, _hoisted_23)
          ]),
          (formErrors.value.server_error !== undefined)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 1,
                variant: "danger",
                class: "js-form-error",
                dismissible: "",
                onDismissed: _cache[4] || (_cache[4] = ($event: any) => (formErrors.value = {}))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 40, _hoisted_2))
  ], 64))
}
}

})